import banner from 'assets/images/trade-in-search-bar.png';
import popup from 'assets/images/trade-in.png';
import buttonImg from 'assets/images/trade-in-button.png';
import btnPopup from 'assets/images/trade-in-popup.png';
import creditBanner from 'assets/images/creditBanner.png';
import creditBanner2 from 'assets/images/credit_banner_2.png';
import creditPopup from 'assets/images/creditPopup.png';
import creditButton from 'assets/images/creditButton.png';
import creditPopupButton from 'assets/images/creditBtnPopup.png';
import leadgenEmbed from 'assets/images/leadgenEmbed.png';
import leadgenButton from 'assets/images/leadgenButton.png';

export const scripts: { setupScript: string } = {
  setupScript: `<script src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" async></script>`,
};

export interface TabInfo {
  label: string;
  description: string | null;
  code: string | null;
  image: string[];
}

export const tabInfo: TabInfo[] = [
  {
    label: 'Banner',
    description: 'Add this element where you want the Banner to appear on the page.',
    code: `<!DOCTYPE html>
          <html>
          <head>
              <title>Trade-In Widget</title>
              <script>
                  window.WIDGET_CONFIG = {
                      parentSelector: '#search-component-container',
                      widgetData: {
                          customClassName: 'custom-class-name',
                          token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                          type: 'banner',
                          version: '1.1',
                          module: 'trade-in',
                      },
                  };
              </script>
              <script src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" async></script>
          </head>
          <body>
              <div id="search-component-container"></div>
          </body>
          </html>`,
    image: [banner, popup],
  },
  {
    label: 'Multiple Banner',
    description: 'Add this element where you want the Banner to appear on the page.',
    code: `<!DOCTYPE html>
          <html>
          <head>
              <title>Trade-In Widget</title>
              <script>
                  window.WIDGET_CONFIG = {
                      parentSelector: ['#search-component-container-1','#search-component-container-2'],
                      widgetData: {
                          customClassName: 'custom-class-name',
                          token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                          type: 'banner',
                          version: '1.1',
                          module: 'trade-in',
                      },
                  };
              </script>
              <script src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" async></script>
          </head>
          <body>
              <div id="search-component-container-1"></div>
              <div id="search-component-container-2"></div>
          </body>
          </html>`,
    image: [banner, banner],
  },

  {
    label: 'Button',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        window.WIDGET_CONFIG = {
            parentSelector: '#button-component-container',
            widgetData: {
                type: 'button',
                version: '1.1',
                module: 'trade-in',
                token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                customClassName: 'custom-class-name',
            },
        };
    </script>
    <script 
        src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
        async>
    </script>
</head>
<body>
    <div id="button-component-container"></div>
</body>
</html>
`,

    image: [buttonImg, btnPopup],
  },

  {
    label: 'Multiple Button',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        window.WIDGET_CONFIG = {
            parentSelector: ['#button-component-container-1','#button-component-container-2'],
            widgetData: {
                type: 'button',
                version: '1.1',
                module: 'trade-in',
                token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                customClassName: 'custom-class-name',
            },
        };
    </script>
    <script 
        src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
        async>
    </script>
</head>
<body>
    <div id="button-component-container-1"></div>
    <div id="button-component-container-2"></div>
</body>
</html>
`,

    image: [buttonImg, buttonImg],
  },

  {
    label: 'Multiple Widgets',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        window.WIDGET_CONFIG = [
            {
                parentSelector: '#button-component-container-1',
                widgetData: {
                    type: 'button',
                    version: '1.1',
                    module: 'trade-in',
                    token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                    customClassName: 'custom-class-name',
                },
            },
            {
                parentSelector: ['#search-component-container-1', '#search-component-container-2'],
                widgetData: {
                    type: 'banner',
                    version: '1.1',
                    module: 'trade-in',
                    token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                    customClassName: 'custom-class-name',
                },
            },
        ];
    </script>

    <script 
        src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
        async>
    </script>
</head>
<body>
    <div id="button-component-container-1"></div>
    <div id="search-component-container-1"></div>
    <div id="search-component-container-2"></div>
</body>
</html>
`,

    image: [buttonImg, banner, banner],
  },
];

export const tabInfoCredit: TabInfo[] = [
  {
    label: 'Banner',
    description: 'Add this element where you want the Banner to appear on the page.',
    code: `<!DOCTYPE html>
            <html>
            <head>
                <title>Trade-In Widget</title>
                <script>
                    window.WIDGET_CONFIG = {
                        parentSelector: '#credit-component-container',
                        widgetData: {
                            customClassName: 'custom-class-name',
                            token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                            type: 'banner',
                            version: '1.0',
                            module: 'credit-score',
                            design: 'dabadu', // 'equifax'
                        },
                    };
                </script>
                <script src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" async></script>
            </head>
            <body>
                <div id="credit-component-container"></div>
            </body>
            </html>`,
    image: [creditBanner, creditPopup],
  },
  {
    label: 'Button',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
  <html lang="en">
  <head>
      <script>
          window.WIDGET_CONFIG = {
              parentSelector: '#button-component-container',
              widgetData: {
                  type: 'button',
                  version: '1.0',
                  module: 'credit-score',
                  token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                  customClassName: 'custom-class-name',
              },
          };
      </script>
      <script 
          src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
          async>
      </script>
  </head>
  <body>
      <div id="button-component-container"></div>
  </body>
  </html>
  `,

    image: [creditButton, creditPopupButton],
  },
  {
    label: 'Multiple Banner',
    description: 'Add this element where you want the Banner to appear on the page.',
    code: `<!DOCTYPE html>
          <html>
          <head>
              <script>
                  window.WIDGET_CONFIG = {
                      parentSelector: ['#credit-component-container-1','#credit-component-container-2'],
                      widgetData: {
                          customClassName: 'custom-class-name',
                          token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                          type: 'banner',
                          version: '1.0',
                          module: 'credit-score',
                          design: 'equifax', // 'dabadu'
                      },
                  };
              </script>
              <script src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" async></script>
          </head>
          <body>
              <div id="credit-component-container-1"></div>
              <div id="credit-component-container-2"></div>
          </body>
          </html>`,
    image: [creditBanner2, creditBanner2],
  },

  {
    label: 'Multiple Button',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        window.WIDGET_CONFIG = {
            parentSelector: ['#button-component-container-1','#button-component-container-2'],
            widgetData: {
                type: 'button',
                version: '1.0',
                module: 'credit-score',
                token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                customClassName: 'custom-class-name',
            },
        };
    </script>
    <script 
        src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
        async>
    </script>
</head>
<body>
    <div id="button-component-container-1"></div>
    <div id="button-component-container-2"></div>
</body>
</html>
`,

    image: [creditButton, creditButton],
  },

  {
    label: 'Multiple Widgets',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        window.WIDGET_CONFIG = [
            {
                parentSelector: '#button-component-container-1',
                widgetData: {
                    type: 'button',
                    version: '1.1',
                    module: 'trade-in',
                    token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                    customClassName: 'custom-class-name',
                },
            },
            {
                parentSelector: ['#credit-component-container-1', '#credit-component-container-2'],
                widgetData: {
                    type: 'banner',
                    version: '1.0',
                    module: 'credit-score',
                    token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                    customClassName: 'custom-class-name',
                    design: 'dabadu', // 'equifax'
                },
            },
        ];
    </script>

    <script 
        src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
        async>
    </script>
</head>
<body>
    <div id="button-component-container-1"></div>
    <div id="credit-component-container-1"></div>
    <div id="credit-component-container-2"></div>
</body>
</html>
`,

    image: [buttonImg, creditBanner, creditBanner],
  },
];

export const tabInfoLeadGen: TabInfo[] = [
  {
    label: 'Button',
    description: 'Add this element where you want the CTA to appear on the page.',
    code: `<!DOCTYPE html>
  <html lang="en">
  <head>
      <script>
          window.WIDGET_CONFIG = {
              parentSelector: '#button-component-container',
              widgetData: {
                  type: 'button',
                  version: '1.0',
                  module: 'lead-gen',
                  token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                  customClassName: 'custom-class-name',
              },
          };
      </script>
      <script 
          src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
          async>
      </script>
  </head>
  <body>
      <div id="button-component-container"></div>
  </body>
  </html>
  `,

    image: [creditButton, leadgenButton],
  },
  {
    label: 'Embed',
    description: 'Add this element where you want the Embed form.',
    code: `<!DOCTYPE html>
  <html lang="en">
  <head>
      <script>
          window.WIDGET_CONFIG = {
              parentSelector: '#button-component-container',
              widgetData: {
                  type: 'embed',
                  version: '1.0',
                  module: 'lead-gen',
                  token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
                  customClassName: 'custom-class-name',
              },
          };
      </script>
      <script 
          src="https://widget-v1.dabadu.dev/widget/widgetBundle.js" 
          async>
      </script>
  </head>
  <body>
      <div id="button-component-container"></div>
  </body>
  </html>
  `,

    image: [leadgenEmbed],
  },
  //   {
  //     label: 'Multiple Button',
  //     description: 'Add this element where you want the CTA to appear on the page.',
  //     code: `<!DOCTYPE html>
  // <html lang="en">
  // <head>
  //     <script>
  //         window.WIDGET_CONFIG = {
  //             parentSelector: ['#button-component-container-1','#button-component-container-2'],
  //             widgetData: {
  //                 type: 'button',
  //                 version: '1.0',
  //                 module: 'lead-gen',
  //                 token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
  //                 customClassName: 'custom-class-name',
  //             },
  //         };
  //     </script>
  //     <script
  //         src="https://widget-v1.dabadu.dev/widget/widgetBundle.js"
  //         async>
  //     </script>
  // </head>
  // <body>
  //     <div id="button-component-container-1"></div>
  //     <div id="button-component-container-2"></div>
  // </body>
  // </html>
  // `,

  //     image: [creditButton, creditButton],
  //   },

  //   {
  //     label: 'Multiple Widgets',
  //     description: 'Add this element where you want the CTA to appear on the page.',
  //     code: `<!DOCTYPE html>
  // <html lang="en">
  // <head>
  //     <script>
  //         window.WIDGET_CONFIG = [
  //             {
  //                 parentSelector: '#button-component-container-1',
  //                 widgetData: {
  //                     type: 'button',
  //                     version: '1.0',
  //                     module: 'lead-gen',
  //                     token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
  //                     customClassName: 'custom-class-name',
  //                 },
  //             },
  //             {
  //                 parentSelector: ['#credit-component-container-1', '#credit-component-container-2'],
  //                 widgetData: {
  //                     type: 'embed',
  //                     version: '1.0',
  //                     module: 'lead-gen',
  //                     token: 'Z1BJRUZuS2U0dUl6UnNua2FMSGw*****',
  //                     customClassName: 'custom-class-name',
  //                 },
  //             },
  //         ];
  //     </script>

  //     <script
  //         src="https://widget-v1.dabadu.dev/widget/widgetBundle.js"
  //         async>
  //     </script>
  // </head>
  // <body>
  //     <div id="button-component-container-1"></div>
  //     <div id="credit-component-container-1"></div>
  //     <div id="credit-component-container-2"></div>
  // </body>
  // </html>
  // `,

  //     image: [buttonImg, creditBanner, creditBanner],
  //   },
];
